var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-datatable-wrapper"},[_c('div',{staticClass:"sf-datatable-container"},[_c('div',{staticClass:"tree-section-container",class:{ empty: _vm.menuTree.length === 0 }},[_c('div',[_c('el-tree',{attrs:{"data":_vm.menuTree},on:{"node-click":_vm.handleNodeClick}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }